import { ref, onDeactivated, onActivated } from '@vue/composition-api';
import { useDomListener } from '@/common/utils';
export function useScrollActive(elReg: string) {
    const pageOffsetTop = ref(0);
    const scrollHeight = ref(0);
    // @ts-ignore
    useDomListener(() => window, 'scroll', (e: Event) => {
        pageOffsetTop.value = (e.target as any).scrollingElement?.scrollTop || 0;
    });
    onActivated(() => {
        // @ts-ignore
        document.querySelector(elReg).scrollTop = scrollHeight.value;
    });
    onDeactivated(() => {
        scrollHeight.value = pageOffsetTop.value;
    });
    return {
        pageOffsetTop,
        scrollHeight,
    };
}